"use client"

import {  Filter, ChevronDown} from 'lucide-react';
import { Product } from '@cabukaka/types';

interface FiltersBarProps {
 products: Product[],
 sort: string
}

export default function FiltersBar({products , sort}: FiltersBarProps) {
  return (
      <div className="sticky top-0 z-20 bg-white/90 backdrop-blur-md border-b border-gray-100 shadow-sm">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between gap-4 py-3">

                        {/* Compteur */}
                        <p className="text-sm text-gray-500 hidden md:block">
                            <span className="font-semibold text-gray-800 text-base">{products.length}</span>{' '}
                            produit{products.length !== 1 ? 's' : ''}
                        </p>

                        {/* Bouton filtre mobile */}
                        <button className="flex md:hidden items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-xl text-gray-700 text-sm font-medium transition-colors">
                            <Filter className="w-4 h-4" />
                            Filtrer
                        </button>

                        {/* Droite : vue + tri */}
                        <div className="flex items-center gap-3 ml-auto">



                            {/* Sélecteur tri */}
                            <div className="relative">
                                <select
                                    defaultValue={sort}
                                    className="appearance-none bg-gray-100 hover:bg-gray-200 pl-4 pr-9 py-2 rounded-xl text-sm font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-orange-400 cursor-pointer transition-colors"
                                >
                                    <option value="latest">Plus récents</option>
                                    <option value="price-asc">Prix croissant</option>
                                    <option value="price-desc">Prix décroissant</option>
                                    <option value="popular">Les plus populaires</option>
                                </select>
                                <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400 pointer-events-none" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

  )
}
